export default {
  lista: [],
  estaCarregando: false,
  listaFuncionarios: false,
  filtros: {
    data_inicial: "",
    data_final: "",
    curso: null,
    livro: null,
    idioma: null,
    situacaoTurma: null,
    turma: null,
    funcionario: null,
    modalidade_turma: null,
    aluno: null,
    licao: null,
  },
};
